<!--
    Summary:
        首页
    ChangeLog:
        Labbor on 2020/2/21 added
-->
<template>
  <div class="v-home">
    

    <el-dialog
      title="公告"
      :visible.sync="dialogNoticeVisible"
      width="60%" center
      :before-close="handleClose">
      <a :href="notice.FullPdfUrl" target="_blank">
        <img :src="notice.FullPdfImgUrl" width="100%" />
      </a>
    </el-dialog>
  </div>
</template>

<script>
  import {GetNewNewly} from '@/service/searchreport'
  var setHeight = function () {
    var height = $(window).height();
    var navbarHeight = $('.ct-header.navbar').height();
    $('.banners').height(height - navbarHeight)
    $('.banner-img').height(height - navbarHeight)
    $('.el-carousel__container').height(height - navbarHeight)
    console.log('setHeight', height, navbarHeight);
  }

  var scrollBg = function () {
    document.onscroll = function (e) {
      //console.log('onscroll' , e)
      var scrollTop = $(document).scrollTop(), max = 278,
        diff = scrollTop - 689;

      var top = (max - diff) * 0.5;
      top = top > max ? max : top;
      //console.log('scrollBg top', top);
      $('.samples').css('background-position', '50% ' +  top + 'px');

    }
  }

  var setBannerDelay = function () {
    let $items = $('.v-home .banners .el-carousel__item'),
      len = $items.length;

    for (let i = 0; i <len; i++) {
      let $children = $items.eq(i).find('.tp-parallax-wrap'), cLen = $children.length;
      for (let j = 0; j < cLen; j++) {
        $children.eq(j).css('transition-delay', '.' + j + 's');
      }
    }
  }


  var animation = function (e) {
    count++;
    curTop = window.scrollY;

    let $imgs = $(rootClass).find('img'), $img, imgTop, diff, len = $imgs.length;

    for (let i = 0; i < len; i++) {
      $img = $imgs.eq(i);
      imgTop = $img.offset().top;
      //console.log('animation', imgTop,  windowHeight)
      if (curTop === 0) {
        if (imgTop < windowHeight) { //首屏图片, 立刻开始动画
          $img.addClass('img-slide');
        }else{//不在第一屏的图片
          $img.removeClass('img-slide');
        }
      }
      else if (!$img.hasClass('img-slide')){
        diff = imgTop - curTop - windowHeight;
        if (diff < -10){ //误差
          $img.addClass('img-slide');
        }
      }
    }
  };
  export default {
    data() {
      return {
        clinicsCount: 0, //本地诊所数量
        sampleCount: 0, //处理样本数目
        clinicsMaxCount: 26,
        sampleMaxCount: 100000,
        notice: {},
        dialogNoticeVisible: false,
      }
    },
    mounted() {
      // if (this.isMobileDevice()) {//是手机 跳转到手机地址
        
      //     window.location.href="http://m.hkmedilab.com/#/search";
      // }

      setTimeout(setHeight, 200);
      scrollBg();
      setBannerDelay();

      setTimeout(()=>{
        window.onscroll = this.animation;
      }, 200);
      this.getNotice();
    },
    methods: {
      isMobileDevice(){
          let isMobile = false;
          let thisOS = navigator.platform,
              userAgent = navigator.userAgent,
              appVersion = navigator.appVersion;
          let os = ["iPhone","iPod","iPad","android","Nokia","SymbianOS","Symbian","Windows Phone","Phone","Linux armv71","MAUI","UNTRUSTED/1.0","Windows CE","BlackBerry","IEMobile"];
          for(let i=0;i<os.length;i++)
              if(thisOS.match(os[i]) || userAgent.match(os[i] || appVersion.match(os[i])))
                  isMobile = true;

          //因为相当部分的手机系统不知道信息,这里是做临时性特殊辨认
          if(navigator.platform.indexOf('iPad') != -1)
              isMobile = true;

          //做这一部分是因为Android手机的内核也是Linux
          //但是navigator.platform显示信息不尽相同情况繁多,因此从浏览器下手，即用navigator.appVersion信息做判断
          if(appVersion.match(/linux/i) )
              //X11是UC浏览器的平台 ，如果有其他特殊浏览器也可以附加上条件
              if(appVersion.match(/mobile/i) || appVersion.match(/X11/i))
                  isMobile = true;

          return isMobile;
      },
      onBannerChange(index){
        console.log('onBannerChange', index)
      },
      animation(){
        var curTop = window.scrollY,
           windowHeight = $(window).height(),
           $el = $('.samples'),
           top = $el.offset().top,
           diff = top - curTop - windowHeight;
        //console.log('animation diff, top, curTop, windowHeight', diff, top, curTop, windowHeight)
        if (diff < -120){ //误差
          this.counter();
        }
      },
      handleClose(){
        this.dialogNoticeVisible = false;
        sessionStorage.setItem('isNoticed', 'true');
      },
      async getNotice(){
        this.dialogNoticeVisible = false;
        let isNoticed = sessionStorage.getItem('isNoticed');
        if (isNoticed === "true") {
          return;
        }

        let notice = await GetNewNewly();
        if (notice) { //有公告
          notice.FullPdfImgUrl = process.env.BASE_URL + notice.PdfImgUrl;
          notice.FullPdfUrl = process.env.BASE_URL + notice.PdfUrl;
          this.notice = notice;
          this.dialogNoticeVisible = true;
        }
      },
      counter(){
        var inter = setInterval(()=>{
          if (this.clinicsCount < this.clinicsMaxCount) {
            this.clinicsCount++;
          }
          if (this.sampleCount < this.sampleMaxCount) {
            this.sampleCount+=3846;
          }
          if (this.clinicsCount >= this.clinicsMaxCount && this.sampleCount >= this.sampleMaxCount) {
            this.clinicsCount = this.clinicsMaxCount;
            this.sampleCount = this.sampleMaxCount;
            clearInterval(inter);
          }
        }, 50)

      },
       liJump(path){
            this.$router.push({
            path:path
        })
       },
    },
  }
</script>

<!-- banner 动画 -->
<style>
 
</style>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/view/home_bak.vue